export default {
      id: "icon-search-usage",
      viewBox: "0 0 22 22",
      url: "../icon/" + "icons.svg#icon-search-usage",
      toString: function () {
        return this.url;
      }
    }